"use client";

import { createContext, useContext } from "react";

export interface CurrencyPrices {
  basicPrice: string;
  premiumPrice: string;
  rebateAmount: string;
}

// The site layout supplies the request's prices to both SSR and hydration.
// Outside that layout, callers retain their translated price fallback.
export const CurrencyPricesContext = createContext<CurrencyPrices | null>(null);

export function useCurrencyPrices(): CurrencyPrices | null {
  return useContext(CurrencyPricesContext);
}
